




































import Vue, { PropType } from 'vue';
import { ISegment, IABTestModalProp } from '@/store/types';
import * as actions from '@/store/action-types';

export default Vue.extend({
  name: 'ABTestFinishModal',
  data() {
    return {
      saving: false as boolean,
    };
  },
  props: {
    show: {
      type: Boolean,
    },
    abTest: {
      type: Object as PropType<IABTestModalProp>,
    },
  },
  methods: {
    getSegmentName(segmentId: string): ISegment | undefined {
      if (!segmentId) {
        return undefined;
      }
      const segment = this.$store.state.segments[segmentId];
      if (segment) {
        return segment.name;
      }
      return undefined;
    },
    async confirmABTestFinish() {
      if (this.abTest && this.abTest.selectedABTest) {
        this.saving = true;
        await this.$store.dispatch(actions.UPDATE_AB_TEST, {
          id: this.abTest.selectedABTest._id,
          reload: true,
          data: {
            completedAt: new Date(),
            winner: this.abTest.winner,
            enabled: false,
          },
        });
        if (this.$route.path !== '/cancellation/flows') {
          this.$router.push({ path: '/cancellation/flows' });
        } else {
          this.saving = false;
          this.$emit('close');
        }
      }
    },
  },
});
